import './sentry'
import './app.config'
import './app.routes'
import './app.auth'
import './app.run'
import './app.values'
import './js/directives/minMaxValidation'
import './js/directives/moneyHandling'
import './js/directives/numberHandling'
import './js/directives/dateHandling'
import './js/directives/datePicker'
import './js/components/linkQboEntity/linkQboEntity'
import './js/components/quickTags/quickTags'
import './js/components/projects/itemsSummary'
import './js/components/elementsSidebar/elements-sidebar'
import './js/components/fabButtonAdd/fab-button-add'
import './js/components/switch/switch'
import './js/components/imgCover/img-cover'
import './js/components/fabButton/fab-button'
import './js/components/attachmentGallery/attachmentGallery'
import './js/components/connectQboButton/connect-qbo-button'
import './js/components/superUserBanner'
import './js/components/jobDetailDispatch/jobDetailDispatch'
import './js/components/customersDispatch/customersDispatch'
import './js/controllers/maintenances'
import './js/controllers/maintenance'
import './js/controllers/serviceTicket'
import './js/controllers/project'
import './js/controllers/forgotAccount'
import './js/controllers/magicLink'
import './js/controllers/resetPasswordInApp'
import './js/controllers/upgradeHandoff'
import './js/controllers/consultations'
import './js/controllers/vendors'
import './js/controllers/mycompany'
import './js/controllers/tickets'
import './js/controllers/properties'
import './js/controllers/users'
import './js/controllers/signIn'
import './js/controllers/estimates'
import './js/controllers/billing'
import './js/controllers/tenants'
import './js/controllers/customers'
import './js/controllers/projects'
import './js/controllers/account'
import './js/controllers/items'
import './js/controllers/templates'
import './js/controllers/dashboard'
import './js/controllers/attachments'
import './js/controllers/resetAccount'
import './js/services/scrollingHelper'
import './js/services/modalService'
import './js/services/urlParameters'
import './js/services/request.service'
import './js/services/projectAnalysis'
import './js/services/featureFlagService'
import './js/services/userApi.service'
import './js/services/pricingHelper'
import './js/services/modalTabHelper'
import './js/services/permissionHelper'
import './react/services/navigationService'

import('./styles')

import './react/index'

import './app.module'

